
<div fxLayout="column">
    <table mat-table [dataSource]="dataSource" #mytable class="my-table mat-elevation-z8" fxFlex="100">

        <ng-container matColumnDef="factor">
            <th mat-header-cell *matHeaderCellDef> Factor </th>
            <td mat-cell *matCellDef="let element"> {{element.factor}} </td>
        </ng-container>

        <ng-container matColumnDef="porcentajeDeIncidencia">
            <th mat-header-cell *matHeaderCellDef> % de incidencia </th>
            <td mat-cell *matCellDef="let element"> {{element.porcentajeDeIncidencia}} </td>
        </ng-container>

        <ng-container matColumnDef="valor">
            <th mat-header-cell *matHeaderCellDef> Valor </th>
            <td mat-cell *matCellDef="let element"> {{element.valor}} </td>
        </ng-container>


        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <!-- aligne dive to right -->
    <div fxLayoutAlign="end" >
        <div fxLayout="column" >
            <div ><b>Tolerancia al riesgo:</b> {{ponderacionDeRiesgos.toleranciaAlRiesgo}}</div>
            <div><b>Total:</b> {{totalCalculo}}</div>
        </div>
    </div>

</div>